import CustomerAdvancedForm from './CustomerAdvancedForm'

export default CustomerAdvancedForm
